import { render, staticRenderFns } from "./WaluntIndex.vue?vue&type=template&id=20e3685e&scoped=true&"
import script from "./WaluntIndex.vue?vue&type=script&lang=js&"
export * from "./WaluntIndex.vue?vue&type=script&lang=js&"
import style0 from "./WaluntIndex.vue?vue&type=style&index=0&id=20e3685e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e3685e",
  null
  
)

component.options.__file = "WaluntIndex.vue"
export default component.exports